import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ProveedorService } from 'src/app/services/proveedor.service';
import { GenericFormHandlerService } from 'src/app/shared/generic-crud.service';
import { controlHttp, VarType } from 'src/app/shared/models/form.models';

@Component({
  selector: 'app-suppliers-dialog',
  templateUrl: './suppliers-dialog.component.html',
  styleUrls: ['./suppliers-dialog.component.scss']
})
export class SuppliersDialogComponent extends GenericFormHandlerService implements OnInit {

  constructor(
    protected proveedorService: ProveedorService,
    protected toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef?: MatDialogRef<SuppliersDialogComponent>
  ) {
    super(proveedorService, toastr, dialogRef);
    this.configureBasedOnData();
  }

  ngOnInit(): void {
    this.cargarFrm();
    this.initializeForm(this.data.isEdit);
  }

  private configureBasedOnData(): void {
    // this.apiBasePath = 'proveedores';//siempre debe ir null a menos que vaya a un curl especifico
    this.currentOperation = this.data.isEdit ? controlHttp.UPDATE : controlHttp.CREATE;
    
    if (this.data.isEdit && this.data.proveedor) {
      this.apiIdentifier = this.data.proveedor.id;
    }
  }

  private cargarFrm(){
    this.formFields = [
      { 
        fieldName: 'nombre',
        dataType: VarType.TEXT, 
        isVisible: true, 
        initialValue: this.data?.proveedor?.nombre || '', 
        fieldLabel: 'Nombre de la Marca', 
        width: 50,
        validations: [
          { type: 'required', message: 'El nombre es requerido' },
          { type: 'maxLength', value: 100, message: 'Máximo 100 caracteres' }
        ]
      },
      {
        fieldName: 'descripcion',
        dataType: VarType.TEXTAREA,
        isVisible: true, 
        initialValue: this.data?.proveedor?.descripcion || '',
        fieldLabel: 'Descripción', 
        width: 100,
        validations: [
          { type: 'maxLength', value: 500, message: 'Máximo 500 caracteres' }
        ]
      },
    ];
  }

  onCancel(): void {
    if (this.hasUnsavedChanges) {
      // Mostrar confirmación
    } else {
      this.dialogRef?.close();
    }
  }
}
interface DialogData {
  proveedor?: any;
  isEdit: boolean;
}